module.exports = __webpack_public_path__ + "static/media/bg.b8fbb699.png";